import script from "./xianshangzuoyexiangqing.vue?vue&type=script&setup=true&lang=js"
export * from "./xianshangzuoyexiangqing.vue?vue&type=script&setup=true&lang=js"

import "./xianshangzuoyexiangqing.vue?vue&type=style&index=0&id=7f16b65d&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f16b65d"]])

export default __exports__